var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    {
      staticClass: "document mt-4",
      attrs: { "no-body": "" },
      on: {
        click: function($event) {
          return _vm.downloadDocument()
        }
      }
    },
    [
      _c(
        "b-card-body",
        { staticClass: "d-flex align-items-center" },
        [
          _c("font-awesome-icon", {
            staticClass: "file-icon mr-3",
            attrs: { icon: "file-" + _vm.document.documentFormat.toLowerCase() }
          }),
          _vm._v(" "),
          _c("h4", { staticClass: "document-name mb-0" }, [
            _vm._v("\n      " + _vm._s(_vm.document.documentName) + "\n      "),
            _c("span", { staticClass: "document-type" }, [
              _vm._v(_vm._s(_vm.document.documentType))
            ])
          ]),
          _vm._v(" "),
          !_vm.downloading
            ? _c("font-awesome-icon", {
                staticClass: "download-icon",
                attrs: { icon: "cloud-download-alt" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.downloading
            ? _c("font-awesome-icon", {
                staticClass: "download-icon",
                attrs: { icon: "spinner", spin: "" }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17801d0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17801d0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentCard.vue
// module id = bX5v
// module chunks = 1